export const STATS_BASE_URL = 'ui/partner/stats';
export const STORE_MANAGEMENT_STATS_BASE_URL =
  'ui/partner/stats/store_management';

export const statsQueryKeys = {
  all: [STATS_BASE_URL],
  storeManagement: [STORE_MANAGEMENT_STATS_BASE_URL, 'products'],
};
